import { useSelector } from 'react-redux';

export const useIsMapIconDisabled = () => {
  const isObliqueImageryClickable = useSelector(
    state => state?.geoSelection?.obliqueImagery?.isClickable,
  );
  const isAirAmbulanceClickable = useSelector(
    state => state?.geoSelection?.airAmbulance?.isClickable,
  );
  const isMapIconDisabled =
    isObliqueImageryClickable || isAirAmbulanceClickable;

  // currently it is only 2 cases, no need to over complicate it. but can be generalized if needed
  return isMapIconDisabled;
};
